import { useBatchDetail, useBatchEvents } from "@homesite/hooks";
import type { BatchDetailBatch, EventTimelineItem } from "@homesite/ui";
import { BatchDetailPage } from "@homesite/ui";
import { createRoute, useNavigate } from "@tanstack/react-router";
import { rootRoute } from "./__root";

export const batchDetailRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/batches/$root",
	component: function BatchDetail() {
		const { root } = batchDetailRoute.useParams();
		const navigate = useNavigate();
		const { batch, loading, error } = useBatchDetail(root);
		const { events, loading: eventsLoading } = useBatchEvents(root);

		const batchData: BatchDetailBatch | null = batch
			? {
					merkleRoot: batch.merkleRoot,
					recordCount: batch.recordCount,
					createdAt: batch.createdAt,
					anchored: batch.anchored,
					chainName: null,
					txHash: batch.txHash ?? null,
					blockNumber:
						batch.blockNumber != null ? Number(batch.blockNumber) : null,
					blockTimestamp: batch.blockTimestamp ?? null,
					previousBatchRoot: batch.previousBatchRoot ?? null,
					nextBatchRoot: batch.nextBatchRoot ?? null,
				}
			: null;

		const eventItems: EventTimelineItem[] = events.map((e) => ({
			id: e.hash,
			eventType: e.eventType,
			respaCode: e.respaCode,
			respaName: e.respaName,
			hash: e.hash,
			timestamp: e.timestamp,
			verified: e.verified,
			anchored: e.anchored,
		}));

		function handlePrev(): void {
			if (batch?.previousBatchRoot) {
				navigate({
					to: "/batches/$root",
					params: { root: batch.previousBatchRoot },
				});
			}
		}

		function handleNext(): void {
			if (batch?.nextBatchRoot) {
				navigate({
					to: "/batches/$root",
					params: { root: batch.nextBatchRoot },
				});
			}
		}

		return (
			<BatchDetailPage
				batch={batchData}
				loading={loading}
				error={error}
				onPrev={handlePrev}
				onNext={handleNext}
				events={eventItems}
				eventsLoading={eventsLoading}
			/>
		);
	},
});
